var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceTemporalUnpublishedEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C15.26 7 17.5 9.24 17.5 12C17.5 12.65 17.37 13.26 17.14 13.83L20.06 16.75C21.57 15.49 22.76 13.86 23.49 12C21.76 7.61 17.49 4.5 12.49 4.5C11.09 4.5 9.75 4.75 8.51 5.2L10.67 7.36C11.24 7.13 11.85 7 12.5 7ZM2.5 4.27L4.78 6.55L5.24 7.01C3.58 8.3 2.28 10.02 1.5 12C3.23 16.39 7.5 19.5 12.5 19.5C14.05 19.5 15.53 19.2 16.88 18.66L17.3 19.08L20.23 22L21.5 20.73L3.77 3L2.5 4.27ZM8.03 9.8L9.58 11.35C9.53 11.56 9.5 11.78 9.5 12C9.5 13.66 10.84 15 12.5 15C12.72 15 12.94 14.97 13.15 14.92L14.7 16.47C14.03 16.8 13.29 17 12.5 17C9.74 17 7.5 14.76 7.5 12C7.5 11.21 7.7 10.47 8.03 9.8ZM12.34 9.02L15.49 12.17L15.51 12.01C15.51 10.35 14.17 9.01 12.51 9.01L12.34 9.02Z",
    fill: "#A32E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceTemporalUnpublishedEye);
export default __webpack_public_path__ + "static/media/workspace_temporal_unpublished_eye.8df83755827728d9eb7814e08486fdac.svg";
export { ForwardRef as ReactComponent };